import { useParams } from "react-router-dom";
import useUserState from "ui/adapter/state/useUserState";

export default function useProgramAddressAndBackButton(): { programAddress: string; shouldShowBackButton: boolean } {
    const { programAddress } = useParams();
    const { selectedRole } = useUserState();
    const safeProgramAddress = selectedRole?.program?.address as string;

    if (programAddress) return { programAddress, shouldShowBackButton: true };
    return { programAddress: safeProgramAddress, shouldShowBackButton: false };
}
